import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EnumToDescriptionPipe } from './pipes/enum-to-description.pipe';
import { ContactAddComponent } from 'app/modules/contacts/contact-add/contact-add.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MobileNumberDisplayPipe } from './pipes/mobile-number-display.pipe';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BusinessAccountAddComponent } from '../modules/business-accounts/business-account-add/business-account-add.component';
import { SpaceBeforeUpperCasePipe } from './pipes/space-before-upper-case.pipe';
import { HumanizeMillisecondsPipe } from './pipes/humanize-milliseconds.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import {
    MatAutocomplete,
    MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { AppShellComponent } from './components/app-shell/app-shell.component';
import { AdminUiModule } from './components/admin-ui.module';

@NgModule({
    declarations: [
        EnumToDescriptionPipe,
        ContactAddComponent,
        BusinessAccountAddComponent,
        MobileNumberDisplayPipe,
        SpaceBeforeUpperCasePipe,
        HumanizeMillisecondsPipe,
        AppShellComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // MatSidenavModule,
        MatIconModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatDialogModule,
        MatAutocompleteModule,
        NgSelectModule,
        AdminUiModule, // DESIGN-RULES R7: app-discard-confirm in the add-contact modal
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        EnumToDescriptionPipe,
        ContactAddComponent,
        BusinessAccountAddComponent,
        MobileNumberDisplayPipe,
        SpaceBeforeUpperCasePipe,
        HumanizeMillisecondsPipe,
        AppShellComponent,
    ],
    providers: [MobileNumberDisplayPipe],
})
export class SharedModule {}
